export default __webpack_public_path__ + "static/media/google-pay.5f7508c7.png";